<template>
  <div class="bg-white">
    <div class="relative z-index1 h-full w-full">
      <div class="sm-joinus-svg">
        <CoverPage />
        <GalleryTabs
          @name="getName"
          @page="getPage"
          @read="getReadMore"
          @getShareWorks="getShareWorks"
        />
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import CoverPage from "./components/CoverPage.vue";
import GalleryTabs from "./components/GalleryTabs.vue";
import Footer from "../../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      art: "Poetry",
      currentPage: 1,
      perPage: 4,
    };
  },
  components: { CoverPage, GalleryTabs, Footer, DownloadApp },
  watch: {
    async readMore() {
      this.perPage += 4;
      // console.log(this.readMore);
      await this.getShareWorks(this.art);
    },
    async readLess() {
      if (this.perPage > 4) {
        this.perPage -= 4;
        // console.log(this.readLess);
        await this.getShareWorks(this.art);
      }
    },
  },
  methods: {
    async getShareWorks(art) {
      let currPage = this.currentPage - 1;
      let payload = {
        status: "Approved",
        art: art,
        limit: art === "Poetry" ? this.perPage : 100,
        offset: currPage,
        test: "dw",
      };
      try {
        await this.$store.dispatch("hoc/getSharework", payload);
        this.totalRows = this.shareWork.totalCount;
      } catch (error) {
        console.log(error);
      }
    },

    async getName(value) {
      // console.log({ value: value });
      this.art = value;
      this.currentPage = 1;
      this.perPage = 4;
      await this.getShareWorks(this.art);
      // console.log(this.shareWork);
    },
    async getPage(value) {
      this.currentPage = value;
      await this.getShareWorks(this.art);
    },
    async getReadMore(value) {
      this.perPage += 4;
      // console.log(value);
      await this.getShareWorks(this.art);
    },
  },

  computed: {
    ...mapState("hoc", {
      shareWork: "shareWork",
      readMore: "readMore",
      readLess: "readLess",
    }),
    ...mapState("auth", { user: "user" }),
  },

  async mounted() {
    await this.getShareWorks("Poetry");
    // console.log(this.shareWork);
  },
};
</script>

<style></style>
